import { createAction, props } from '@ngrx/store';
import { SingleGraphError } from 'src/app/common-components/errors/models/error-message';
import { DepartmentDetailSaveEvent } from '../models/department-detail-form-submit-event';
import { DepartmentDetailSaveModel } from '../models/department-detail-save.model';
import { GetDepartmentDetail_department } from '../queries/generated/GetDepartmentDetail';

export const departmentDetailLoad = createAction('[Department Detail] Load');

export const departmentDetailCancel = createAction('[Department Detail] Cancel');

export const departmentDetailAccessDenied = createAction('[Department Detail] Access Denied');

export const loadDepartmentDetailSuccess = createAction(
   '[API] Load Department Success',
   props<{ data: GetDepartmentDetail_department }>()
);

export const deleteDepartment = createAction(
   '[Department Detail] Delete Department',
   props<{ departmentId: number; name: string | null }>()
);

export const deleteDepartmentSuccess = createAction(
   '[Department Detail] Delete Department Success',
   props<{ departmentId: number; name: string | null }>()
);

export const deleteDepartmentFailure = createAction(
   '[Department Detail] Delete Department Failure',
   props<SingleGraphError>()
);

export const deleteDepartmentDetailFailure = createAction(
   '[Department Detail] Delete Department Details Failure',
   props<SingleGraphError>()
);

export const renameDepartment = createAction(
   '[Department Detail] Rename Department',
   props<{ departmentId: number; name: string | null }>()
);

export const renameDepartmentConfirmed = createAction(
   '[Department Detail] Rename Department Confirmed',
   props<{ departmentId: number; name: string | null; isActive: boolean }>()
);

export const renameDepartmentCanceled = createAction('[Department Detail] Rename Department Canceled');

export const updateDepartmentId = createAction(
   '[Department Detail] Update Department Id',
   props<{ departmentId: number }>()
);

export const loadDepartmentDetailFailure = createAction('[API] Load Department Failure', props<SingleGraphError>());

export const saveDepartmentDetail = createAction('[Department Detail] Save', props<DepartmentDetailSaveEvent>());

export const saveDepartmentDetailFailure = createAction('[Department Detail] Save Failure', props<SingleGraphError>());

export const loadPageNoDepartment = createAction('[Department Detail] Load Page No Department');

export const deactivateDepartment = createAction(
   '[Department Detail] Deactivate Department',
   props<{ department: DepartmentDetailSaveModel }>()
);

export const mergeDepartment = createAction(
   '[Department Detail] Merge Department',
   props<{ departmentId: number; name: string | null; accountId: number }>()
);

export const mergeDepartmentConfirmed = createAction(
   '[Department Detail] Merge Department Confirmed',
   props<{ sourceDepartmentId: number; destinationDepartmentId: number }>()
);

export const modifyDepartmentSuccess = createAction(
   '[Department Detail] Modify Department Success',
   props<{ message: string }>()
);

export const untagDepartment = createAction(
   '[Department Detail] Untag Department',
   props<{ departmentId: number; name: string | null }>()
);
